import CryptoJS from "crypto-js";

function parseKeyFromEnv(keyB64) {
  // encrypter.js は substring(7) してるので "base64:" 前提っぽい :contentReference[oaicite:5]{index=5}
  const raw = keyB64.startsWith("base64:") ? keyB64.slice(7) : keyB64;
  return CryptoJS.enc.Base64.parse(raw); // 32 bytes想定(AES-256)
}

function tryParsePayload(payloadStr) {
  // 1) そのままJSON
  if (payloadStr.trim().startsWith("{")) {
    return JSON.parse(payloadStr);
  }

  // 2) Base64(JSON)
  const jsonStr = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(payloadStr));
  return JSON.parse(jsonStr);
}

function timingSafeEqualHex(a, b) {
  if (typeof a !== "string" || typeof b !== "string") return false;
  if (a.length !== b.length) return false;
  let r = 0;
  for (let i = 0; i < a.length; i++) r |= a.charCodeAt(i) ^ b.charCodeAt(i);
  return r === 0;
}

function hashDeserialize(data) {
  // encrypter.js と同じ抜き出し :contentReference[oaicite:6]{index=6}
  const str = String(data);
  return str.substring(str.indexOf(":", 2) + 2, str.lastIndexOf(";") - 1);
}

export function decryptStringPayload(payloadStr, VUE_APP_CRYPTO_KEY) {
  if (!payloadStr) return "";

  const key = parseKeyFromEnv(VUE_APP_CRYPTO_KEY);

  let payload;
  try {
    payload = tryParsePayload(payloadStr);
  } catch {
    // 「普通の文字列」が本当に平文なら、そのまま返す運用もあり
    // encrypter.js も失敗したら payload を返す :contentReference[oaicite:7]{index=7}
    return payloadStr;
  }

  if (!payload?.iv || !payload?.value || !payload?.mac) {
    throw new Error("payload に iv/value/mac がありません");
  }

  // mac 検証: HMAC-SHA256( iv + value, key ) :contentReference[oaicite:8]{index=8}
  const expectedMac = CryptoJS.HmacSHA256(String(payload.iv) + String(payload.value), key)
    .toString(CryptoJS.enc.Hex);

  if (!timingSafeEqualHex(String(payload.mac), expectedMac)) {
    throw new Error("mac が一致しません（鍵/形式/データが違う可能性）");
  }

  // AES-256-CBC 復号 :contentReference[oaicite:9]{index=9}
  const iv = CryptoJS.enc.Base64.parse(payload.iv);
  const ciphertext = CryptoJS.enc.Base64.parse(payload.value);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext },
    key,
    { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  const serialized = decrypted.toString(CryptoJS.enc.Utf8);
  return hashDeserialize(serialized);
}
